import { WorkLocationMapper } from "@/javascript/infra/mappers/work-location-mapper"

export const makeWorkLocationMapper = (): WorkLocationMapper => {
  return new WorkLocationMapper()
}
